'use client'

import { useEffect, useState } from 'react'

import { LuCookie } from 'react-icons/lu'
import Button from '../ui/Button'

export function CookieConsent() {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent')
        if (!consent) {
            setVisible(true)
        }
    }, [])

    const acceptCookies = () => {
        localStorage.setItem('cookie-consent', 'accepted')
        setVisible(false)
    }

    if (!visible) return null

    return (
        <div
            className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))]
    left-4 right-4
     md:left-1/2 md:right-auto  md:-translate-x-1/2 z-[99] max-w-md"
        >
            <div className="flex flex-col bg-pimary-hover shadow-xl rounded-2xl p-4 ">
                <div className="flex items-start gap-3">
                    <LuCookie className="text-white shrink-0" size={24} />
                    <p className="text-sm text-white leading-snug">
                        Мы используем файлы cookie для улучшения работы сайта,
                        аналитики и персонализации.
                        <a href="/privacy" className="underline text-primary">
                            Подробнее
                        </a>
                    </p>
                </div>

                <div className="flex justify-end mt-3">
                    <Button
                        size="xs"
                        onClick={acceptCookies}
                        className="ml-auto bg-white text-pimary-hover px-2 py-1 text-sm rounded-xl font-semibold hover:scale-105 transition border-none"
                    >
                        Хорошо
                    </Button>
                </div>
            </div>
        </div>
    )
}
